var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A8E1"
    },
    d: "M161.357,463.055c0,14.887-12.178,27.067-27.065,27.067H35.141 c-14.886,0-27.067-12.179-27.067-27.067V48.945c0-14.887,12.181-27.067,27.067-27.067h99.152c14.886,0,27.065,12.178,27.065,27.067 V463.055z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.075,
    y: 74.668,
    style: {
      fill: "#0071CE"
    },
    width: 153.288,
    height: 47.439
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.075,
    y: 389.9,
    style: {
      fill: "#0071CE"
    },
    width: 153.288,
    height: 47.439
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0055B8"
    },
    d: "M84.718,340.769c-4.461,0-8.075-3.614-8.075-8.075V179.307c0-4.461,3.614-8.075,8.075-8.075 s8.075,3.614,8.075,8.075v153.388C92.793,337.154,89.177,340.769,84.718,340.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0055B8"
    },
    d: "M297.895,463.055c0,14.887-12.178,27.067-27.067,27.067h-82.404 c-14.886,0-27.067-12.179-27.067-27.067V161.317c0-14.885,12.181-27.066,27.067-27.066h82.404 c14.888,0,27.067,12.181,27.067,27.066V463.055z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF9E16"
    },
    cx: 229.624,
    cy: 249.081,
    r: 37.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.909,324.875h-68.565c-4.461,0-8.075-3.616-8.075-8.075c0-4.461,3.614-8.075,8.075-8.075h68.565 c4.461,0,8.075,3.614,8.075,8.075C271.984,321.259,268.37,324.875,263.909,324.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.909,355.954h-68.565c-4.461,0-8.075-3.614-8.075-8.075c0-4.461,3.614-8.075,8.075-8.075h68.565 c4.461,0,8.075,3.614,8.075,8.075C271.984,352.339,268.37,355.954,263.909,355.954z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB6AA"
    },
    d: "M503.003,437.585c3.844,14.379-4.776,29.293-19.155,33.14l-69.095,18.477 c-14.381,3.847-29.296-4.772-33.141-19.152L279.406,87.908c-3.846-14.38,4.774-29.293,19.155-33.139l69.095-18.479 c14.381-3.847,29.295,4.772,33.139,19.152L503.003,437.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071CE"
    },
    d: "M414.191,105.523l-121.392,32.463l11.104,41.512l121.39-32.463L414.191,105.523z M432.943,175.636 l-121.39,32.462l11.102,41.512l121.391-32.463L432.943,175.636z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 428.413,
    cy: 401.701,
    r: 22.863
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.218,367.355c-3.567,0-6.83-2.382-7.795-5.991c-1.152-4.309,1.406-8.735,5.715-9.887 l59.372-15.877c4.299-1.154,8.734,1.406,9.887,5.715c1.152,4.309-1.406,8.735-5.715,9.887L387.31,367.08 C386.612,367.266,385.91,367.355,385.218,367.355z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E252B"
    },
    d: "M510.804,435.5L408.597,53.357c-4.101-15.344-18.079-26.059-33.989-26.059 c-3.043,0-6.084,0.401-9.039,1.192l-69.095,18.479c-9.04,2.417-16.611,8.233-21.318,16.38c-4.708,8.144-5.969,17.608-3.552,26.647 l10.143,37.927c-3.439-1.127-7.108-1.745-10.921-1.745h-82.404c-6.993,0-13.51,2.062-18.992,5.597V48.945 c0-19.377-15.764-35.142-35.14-35.142H35.14C15.765,13.805,0,29.568,0,48.945v414.109c0,19.377,15.765,35.142,35.142,35.142h99.152 c10.877,0,20.614-4.968,27.065-12.754c6.452,7.785,16.189,12.754,27.067,12.754h82.404c19.377,0,35.142-15.765,35.142-35.142 V218.482l67.841,253.655c4.102,15.343,18.081,26.058,33.99,26.058c3.043,0,6.084-0.401,9.039-1.191l69.096-18.477 C504.652,473.519,515.807,454.218,510.804,435.5z M153.282,463.055c0,10.472-8.519,18.992-18.989,18.992H35.141 c-10.471-0.001-18.991-8.521-18.991-18.992v-17.647h137.132L153.282,463.055L153.282,463.055z M153.282,429.258H16.15v-31.285 h137.132L153.282,429.258L153.282,429.258z M153.282,381.823H16.15V130.178h137.132L153.282,381.823L153.282,381.823z  M153.282,114.028H16.15V82.743h137.132L153.282,114.028L153.282,114.028z M153.282,66.592H16.15V48.945 c0-10.472,8.52-18.992,18.992-18.992h99.152c10.471,0,18.989,8.52,18.989,18.992v17.647H153.282z M289.82,463.055 c0,10.472-8.52,18.992-18.992,18.992h-82.404c-10.472,0-18.992-8.52-18.992-18.992V161.317c0-10.472,8.52-18.991,18.992-18.991 h82.404c10.472,0,18.992,8.519,18.992,18.991V463.055z M287.207,85.822c-1.303-4.871-0.616-9.983,1.933-14.393 c2.55-4.41,6.637-7.556,11.509-8.859l69.096-18.479c1.592-0.426,3.23-0.643,4.866-0.643c8.609,0,16.17,5.789,18.387,14.08 l11.308,42.281L298.515,128.1L287.207,85.822z M302.687,143.701l105.79-28.291l6.93,25.909l-105.79,28.291L302.687,143.701z  M313.789,185.213l105.791-28.291l3.477,13l-105.791,28.291L313.789,185.213z M321.439,213.814l105.79-28.291l6.931,25.908 l-105.791,28.291L321.439,213.814z M481.761,462.925l-69.096,18.477c-1.592,0.426-3.23,0.643-4.866,0.643 c-8.609,0-16.172-5.79-18.389-14.08l-56.872-212.641l105.791-28.291l56.872,212.638 C497.906,449.786,491.877,460.219,481.761,462.925z M229.626,203.676c-25.036,0-45.404,20.369-45.404,45.405 s20.368,45.404,45.404,45.404c25.037,0,45.406-20.368,45.406-45.404S254.663,203.676,229.626,203.676z M229.626,278.334 c-16.13,0-29.254-13.123-29.254-29.254s13.124-29.255,29.254-29.255c16.131,0,29.256,13.123,29.256,29.255 C258.881,265.211,245.758,278.334,229.626,278.334z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.093b9fe10cc2fcda719c94450a7ee1e5.svg";
export { ForwardRef as ReactComponent };